import React, { useCallback, useMemo } from 'react'

import { Button, Checkbox, Dropdown, Menu } from 'antd'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import { OverlaySettings } from '../../../../Components/antd/Tables/DragTable/OverlaySettings'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const OverlaySettingsDropdown = ({
  prefix, visible, onVisibleChange, onClick, settings = new OverlaySettings(), trigger = ['click'], placement, className = '', onSelection, t
}) => {
  const settingOptions = useMemo(() => settings.toOptions(prefix), [settings, prefix])

  const handleOverlaySettingCheck = useCallback(setting => checkEvent => {
    onSelection(setting, checkEvent.target.checked)
  }, [onSelection])

  return (
    <Dropdown
      className={className}
      placement={placement}
      trigger={trigger}
      visible={visible}
      onVisibleChange={onVisibleChange}
      onClick={onClick}
      overlay={(
        <Menu>
          {settingOptions.map(o => (
            <Menu.Item key={o.name}>
              <Checkbox className='not-selectable-text' checked={o.isSelected} onChange={handleOverlaySettingCheck(o.name)}>{(t(o.label))}</Checkbox>
            </Menu.Item>
          ))}
        </Menu>
      )}
    >
      <Button>
        {t('quota_table_menu.buttons.select_overlay')}
      </Button>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(OverlaySettingsDropdown)
